export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-6e4946c8b0ced659e64bfac41a8c3521.svg";